import LX from './lx'

// 定义页面PV映射
export const pagePVMap = {
  pay: 'c_offline_payment_rrf3vlb2',
  bind: 'c_offline_payment_offp3zwd',
  error: 'c_offline_payment_azepa7g2',
  paySuccess: 'c_p9hyxoi9', // 鸿蒙支付成功页面PV，与原付款码cid一致
}

// 创建LX事件函数
const createLXEvent = (eventType, eventId) => (lab = {}, option = {}) => {
  LX[eventType](eventId, lab, option)
}

// 创建LX BO事件函数
const createLXBOEvent = (eventType, eventId) => (orderId, lab = {}, option = {}) => {
  LX[eventType](eventId, orderId, lab, option);
}

// 技术指标埋点
const bridgeInvocation = createLXEvent(
  'sc',
  'b_offline_payment_bridge_invocation_sc'
)
const codeDrawing = createLXEvent('sc', 'b_offline_payment_code_drawing_sc')
const paySuccessPageStart = createLXEvent('sc', 'b_pay_success_page_start_sc')

// 业务指标埋点
const mainPagePV = createLXEvent('pv', pagePVMap['pay'])
const closePageMC = createLXEvent('click', 'b_offline_payment_v3fpy7kt_mc')
const topMenuMC = createLXEvent('click', 'b_offline_payment_t4xpssic_mc')
const codeMV = createLXEvent('view', 'b_offline_payment_s8thbkfl_mv')
const codeBO = createLXBOEvent('order', 'b_offline_payment_rrf3vlb2_bo_2016122700000001')
const payTypeMV = createLXEvent('view', 'b_offline_payment_lyhdfsjx_mv')
const payTypeMC = createLXEvent('click', 'b_offline_payment_lyhdfsjx_mc')
const bottomBtnMV = createLXEvent('view', 'b_offline_payment_i34gh12d_mv')
const bottomBtnMC = createLXEvent('click', 'b_offline_payment_i34gh12d_mc')
const topMenuContentMC = createLXEvent('click', 'b_offline_payment_a0nm92dg_mc')
const switchPayTypeModuleMV = createLXEvent(
  'view',
  'b_offline_payment_165q40cv_mv'
)
const switchPayTypeMV = createLXEvent('view', 'b_offline_payment_y4giqaui_mv')
const switchPayTypeMC = createLXEvent('click', 'b_offline_payment_y4giqaui_mc')
const addBankMV = createLXEvent('view', 'b_offline_payment_w3n0mqnw_mv')
const addBankMC = createLXEvent('click', 'b_offline_payment_w3n0mqnw_mc')

// 绑卡页面
const bindCardPV = createLXEvent('pv', pagePVMap['bind'])
const promotionMV = createLXEvent('view', 'b_offline_payment_zlqma96z_mv')
const bindBtnMC = createLXEvent('click', 'b_offline_payment_1soldu7o_mc')
const bindCardMV = createLXEvent('view', 'b_offline_payment_cmggyobb_mv')
const bindCardMC = createLXEvent('click', 'b_offline_payment_cmggyobb_mc')

// 异常页面
const errorPagePV = createLXEvent('pv', pagePVMap['error'])
const errorStatusMV = createLXEvent('view', 'b_offline_payment_ccbz81o7_mv')

// 三方支付渠道埋点
const meituanPayOpenMV = createLXEvent('view', 'b_offline_payment_fbe1mrnu_mv') // 美团支付开通曝光
const meituanPayOpenMC = createLXEvent('click', 'b_offline_payment_fbe1mrnu_mc') // 美团支付开通点击
const alipayMV = createLXEvent('view', 'b_offline_payment_52di0fz7_mv') // 支付宝付款曝光
const alipayMC = createLXEvent('click', 'b_offline_payment_52di0fz7_mc') // 支付宝付款点击
const wechatPayMV = createLXEvent('view', 'b_offline_payment_roxzxlj5_mv') // 微信付款曝光
const wechatPayMC = createLXEvent('click', 'b_offline_payment_roxzxlj5_mc') // 微信付款点击

// 支付成功页面埋点
const paySuccessPagePV = createLXEvent('pv', pagePVMap['paySuccess']) // 支付成功页面PV

// 导出埋点事件
export default {
  bridgeInvocation,
  codeDrawing,
  paySuccessPageStart,
  mainPagePV,
  closePageMC,
  topMenuMC,
  codeMV,
  codeBO,
  payTypeMV,
  payTypeMC,
  bottomBtnMV,
  bottomBtnMC,
  topMenuContentMC,
  switchPayTypeModuleMV,
  switchPayTypeMV,
  switchPayTypeMC,
  addBankMV,
  addBankMC,
  bindCardPV,
  promotionMV,
  bindBtnMC,
  bindCardMV,
  bindCardMC,
  errorPagePV,
  errorStatusMV,
  meituanPayOpenMV,
  meituanPayOpenMC,
  alipayMV,
  alipayMC,
  wechatPayMV,
  wechatPayMC,
  paySuccessPagePV,
}
